module.exports = __webpack_public_path__ + "static/member-1-91b98a285548c2590927cff29e8bfb43.png";